<template>
    <v-hover v-slot="{ hover }" open-delay="200" >
        <div class="app-side-buttons" style="margin-top: 55px" >
            <v-scale-transition>
                <div v-show="hover || permanent || history">
                    <c-menu-button
                        v-if="!readonly && isEditAllowed && (!history || historyEditable) && !download"
                        label      = "unit.edit.menu.edit"
                        icon       = "mdi-pen"
                        icon-color = "primary--text"
                        @click     = "onReadonly"
                    />

                    <c-menu-button
                        v-if="readonly && isEditAllowed && (!history || historyEditable) && !download"
                        label      = "unit.edit.menu.readonly"
                        icon       = "mdi-eye-outline"
                        icon-color = "primary--text"
                        @click     = "onReadonly"
                    />

                    <c-menu-button
                        v-if="!readonly && isEditAllowed && (!history || historyEditable)"
                        label      = "unit.edit.menu.save"
                        icon       = "mdi-content-save-outline"
                        icon-color = "primary--text"
                        @click     = "onSave"
                    />

                    <c-menu-button
                        label      = "unit.edit.menu.refresh"
                        icon       = "mdi-refresh"
                        icon-color = "primary--text"
                        @click     = "onRefresh"
                    />

                    <c-menu-button
                        label      = "unit.edit.menu.close"
                        icon       = "mdi-close"
                        icon-color = "primary--text"
                        @click     = "onClose"
                    />

                    <c-menu-button
                        v-if       = "history"
                        label      = "unit.edit.menu.history"
                        icon       = "mdi-history"
                        icon-color = "primary--text"
                        @click     = "onHistory"
                    />

                    <c-menu-button
                        v-if       = "reports"
                        label      = "unit.edit.menu.reports"
                        icon       = "mdi-printer"
                        icon-color = "primary--text"
                        @click     = "onReports"
                    />

                    <c-menu-button
                        v-if       = "condition"
                        label      = "unit.tzb.budget.title"
                        icon       = "mdi-calculator"
                        icon-color = "primary--text"
                        @click     = "onExtendedConditions"
                    />
                </div>
           </v-scale-transition>
        </div>
    </v-hover>
</template>

<script>

import CMenuButton from "@/modules/core/components/utils/CMenuButton";
import Core from "@/modules/core/service/Core";


export default {
    name: "TSiteMenu",

    components: {
        CMenuButton
    },

    props: {
        ignoreDeleted: {
            required: false,
            type: Boolean,
            default: function () {
                return null;
            }
        },

        edit: {
            required: false,
            type: Boolean,
            default: function () {
                return false;
            }
        },

        condition: {
            required: false,
            type: Boolean,
            default: function () {
                return false;
            }
        },

        history: {
            required: false,
            type: Boolean,
            default: function () {
                return false;
            }
        },

        /** Edit and save stay available next to the history (escalator TZB notes, HCIT-937). */
        historyEditable: {
            required: false,
            type: Boolean,
            default: function () {
                return false;
            }
        },

        reports: {
            required: false,
            type: Boolean,
            default: function () {
                return false;
            }
        },


        download: {
            required: false,
            type: Boolean,
            default: function () {
                return false;
            }
        },
    },

    data: () => ({
        readonly : true
    }),

    mounted() {
        this.deleted = this.ignoreDeleted;
        this.readonly = !this.edit
    },

    watch: {
        edit () {
            this.readonly = !this.edit
        }
    },

    computed: {
        permanent () {
            return this.preferences["permanentMenu"];
        },

        preferences () {
            return this.$store.getters.preferences;
        },

        isEditAllowed () {
            return Core.role.masterdata();
        },
    },

    methods: {
        onReadonly () {
            this.readonly = !this.readonly;
            this.$emit("readonly", this.readonly);
        },

        onSave () {
            this.$emit("save");
        },

        onRefresh () {
            this.$emit("refresh");
        },

        onClose () {
            this.$emit("close");
        },

        onHistory () {
            this.$emit("history");
        },

        onReports () {
            this.$emit("reports");
        },

        onExtendedConditions () {
            this.$emit("extended-conditions");
        }
    }
}
</script>
